module.exports = __webpack_public_path__ + "static/img/logo.e04cf3f9.svg";